"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _lottieWeb = _interopRequireDefault(require("lottie-web"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var LottieAnimation = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var id = props.id,
      className = props.className,
      ariaLabel = props.ariaLabel,
      data = props.data;
  var DIRECTION_FORWARD = 1;
  var DIRECTION_BACKWARDS = -1;
  var lottieClasses = (0, _classnames.default)('Lottie', className);
  var refInternal = (0, _react.useRef)(null);
  var lottieAnimation = ref || refInternal;
  var lottieId = id || (data ? data.nm : null);
  /*
  * Initial load of the Lottie animation
  */

  var loadAnimation = (0, _react.useCallback)(function () {
    var renderer = props.renderer,
        rendererSettings = props.rendererSettings,
        direction = props.direction,
        loop = props.loop,
        autoPlay = props.autoPlay,
        path = props.path,
        speed = props.speed,
        segments = props.segments,
        activateOnHover = props.activateOnHover,
        startPosition = props.startPosition,
        onInit = props.onInit;
    lottieAnimation.current = _lottieWeb.default.loadAnimation({
      animationData: data,
      container: document.getElementById("lottie--".concat(lottieId)),
      renderer: renderer,
      rendererSettings: rendererSettings,
      direction: direction,
      loop: activateOnHover ? false : loop,
      autoplay: activateOnHover ? false : autoPlay,
      path: path
    });
    onInit(lottieAnimation.current); // Set the default speed.

    lottieAnimation.current.setSpeed(speed); // Play segments if we have them.

    if (segments) {
      lottieAnimation.current.playSegments(segments);
    } // If startPosition is defined use it as a starting frame, startPosition should be between 0 and 1.


    if (startPosition) {
      var startingFrame = Math.round(lottieAnimation.current.totalFrames * startPosition);
      lottieAnimation.current.goToAndStop(startingFrame, true);
    }
  }, [data, lottieAnimation, lottieId, props]);
  /*
  * Reverse direction on Mouse enter.
  */

  var onMouseEnter = function onMouseEnter(e) {
    var activateOnHover = props.activateOnHover;

    if (activateOnHover) {
      lottieAnimation.current.setDirection(DIRECTION_FORWARD);
      lottieAnimation.current.play();
    }
  };
  /*
  * Reverse direction on Mouse leave
  */


  var onMouseLeave = function onMouseLeave() {
    var activateOnHover = props.activateOnHover;

    if (activateOnHover) {
      lottieAnimation.current.setDirection(DIRECTION_BACKWARDS);
      lottieAnimation.current.play();
    }
  };
  /*
  * Toggle the animation on click
  */


  var onClick = function onClick() {
    var pauseOnClick = props.pauseOnClick;

    if (pauseOnClick) {
      if (lottieAnimation.current.isPaused) {
        lottieAnimation.current.play();
      } else {
        lottieAnimation.current.pause();
      }
    }
  }; // Init the Lottie animation.


  (0, _react.useEffect)(function () {
    var onDestroy = props.onDestroy;
    loadAnimation();
    return function () {
      onDestroy(lottieAnimation.current);
      lottieAnimation.current.destroy();
    };
  }, [props, loadAnimation, lottieAnimation]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/interactive-supports-focus
    _react.default.createElement("div", {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: onClick,
      className: lottieClasses,
      id: "lottie--".concat(lottieId),
      "aria-label": ariaLabel,
      role: "button"
    })
  );
});

var _default = LottieAnimation;
exports.default = _default;